var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border color-yellow-dark",staticStyle:{"height":"10px","width":"10px","vertical-align":"middle"},attrs:{"role":"status"}})}
var staticRenderFns = []

export { render, staticRenderFns }